import { render, staticRenderFns } from "./DetailForm.vue?vue&type=template&id=f59b6064"
import script from "./DetailForm.vue?vue&type=script&lang=js"
export * from "./DetailForm.vue?vue&type=script&lang=js"
import style0 from "./DetailForm.vue?vue&type=style&index=0&id=f59b6064&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports